module.exports = __webpack_public_path__ + "static/media/logo-aht.11291248.jpg";